import React, { useState, useEffect } from 'react';
import './permission.css';
import SidebarSisboard from '../../components/sidebar/sidebar';
import Topbar from '../../components/topbar/topbar';
import { useFetch } from '../../components/hooks/useFetch';
import { Prefix } from '../../services/prefix';
import { FaArrowLeft } from 'react-icons/fa';
import EquipmentView from './equipamentView';

const Monitoramento = ({ match }) => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fullScreen, setFullScreen] = useState(false);
  const [hideHeaderTexts, setHideHeaderTexts] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

    const idUser = match?.params?.id; 

  return (
    <div className={`wrapper d-flex align-items-stretch ${fullScreen ? 'fullscreen-mode' : ''}`}>
      {!fullScreen && <SidebarSisboard />}
      <div id="content" className={fullScreen ? 'full-content' : ''}>
        {!fullScreen && <Topbar />}
        <div className="content_all">
          
          <div className="page-header">
            <div className="header" style={{ display: "flex", alignItems: "center", gap: 15 }}>
              
              {/* 🔙 BOTÃO DE VOLTAR */}
              <button
                onClick={() => window.history.back()}
                style={{
                  background: "transparent",
                  border: "none",
                  cursor: "pointer",
                  padding: 6,
                  display: "flex",
                  alignItems: "center"
                }}
              >
                <FaArrowLeft size={22} color="#333" />
              </button>

              {!hideHeaderTexts && (
                <div style={{ marginLeft: -5 }}>
                  <h1 className="page-title">Permissões de equipamentos</h1>
                  <p className="page-subtitle">Acompanhe em tempo real os contratos e seus sensores</p>
                </div>
              )}
            </div>
          </div>

          <div className="content_all content-main" style={{ marginTop: 20 }}>
              <EquipmentView idUser={idUser} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Monitoramento;